import { useState, useEffect } from 'react'
import { AdminLayout } from '../../components/layouts/Layout'
import { DataTable } from '../../components/common/DataTable'
import { Badge } from '../../components/common/UI'
import { UserX } from 'lucide-react'
import { formatters } from '../../utils/formatting'
import { userService } from '../../services/api'

export default function AppUsers() {
  const [users, setUsers] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    try {
      const data = await userService.list()
      setUsers(data)
    } catch (error) {
      console.error('Failed to load users:', error)
    } finally {
      setLoading(false)
    }
  }

  const toggleUserStatus = async (user: any) => {
    await userService.update(user.id, { isDeactivated: !user.isDeactivated })
    await loadData()
  }

  const columns = [
    { key: 'fullName' as const, label: 'Name' },
    { 
      key: 'username' as const, 
      label: 'Username',
      render: (value: string) => `@${value}`
    },
    { key: 'email' as const, label: 'Email' },
    {
      key: 'interests' as const,
      label: 'Interests',
      render: (value: string[]) => value?.length || 0
    },
    {
      key: 'isDeactivated' as const,
      label: 'Status',
      render: (value: boolean) => (
        <Badge variant={!value ? 'success' : 'error'}>
          {!value ? 'Active' : 'Deactivated'}
        </Badge>
      )
    },
    {
      key: 'createdAt' as const,
      label: 'Joined',
      render: (value: string) => formatters.date(value)
    }
  ]

  const actions = [
    {
      icon: UserX,
      label: 'Toggle Status',
      onClick: toggleUserStatus,
      variant: 'ghost' as const
    }
  ]

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center min-h-screen">
          <p>Loading...</p>
        </div>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">App Users</h1>
          <p className="text-gray-600">Manage BlastTime users</p>
        </div>

        <DataTable data={users} columns={columns} actions={actions} onSearch={() => {}} />
      </div>
    </AdminLayout>
  )
}